import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

/**
 * The one Supabase client. It carries the publishable key and the signed-in
 * user's session, nothing more: every row Desk can see is decided by RLS
 * (is_staff(): a row in `staff` for the signed-in user). Privileged
 * actions go through Edge Functions that check the same thing server-side.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !key) {
  throw new Error('Desk: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set (see desk/.env.*).');
}

export const supabase = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Desk never receives auth redirects (no magic links, no OAuth), so it
    // has no reason to parse tokens out of the URL.
    detectSessionInUrl: false,
    storageKey: 'bitbew-desk-auth',
  },
});

export const SUPABASE_URL = url;
